// extracted by mini-css-extract-plugin
export const upcomingEventCard = "upcoming-events-module--upcomingEventCard--1234e";
export const eventTime = "upcoming-events-module--eventTime--2jiQ7";
export const heading = "upcoming-events-module--heading--2RO9W";
export const description = "upcoming-events-module--description--2nGXA";
export const eventTimes = "upcoming-events-module--eventTimes--1ZCYp";
export const eventTimeLabel = "upcoming-events-module--eventTimeLabel--l3FqY";